/* SVARTWEAR — Kopfzeile, Navigation, Einblenden beim Scrollen.
   Kein Framework, kein externes CDN. Laeuft mit defer. */
(function () {
  'use strict';

  /* ── Kopfzeile wird beim Scrollen deckender ──────────────────────────── */
  var header = document.querySelector('[data-sw-header]');
  if (header) {
    var ticking = false;
    var setState = function () {
      header.setAttribute('data-scrolled', window.scrollY > 24 ? 'true' : 'false');
      ticking = false;
    };
    setState();
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(setState);
      }
    }, { passive: true });
  }

  /* ── Vollbild-Menue auf schmalen Fenstern ────────────────────────────── */
  var burger = document.querySelector('[data-sw-burger]');
  var nav = document.querySelector('[data-sw-nav]');

  if (burger && nav) {
    var close = function () {
      nav.setAttribute('data-open', 'false');
      burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.removeProperty('overflow');
    };

    burger.addEventListener('click', function () {
      var open = nav.getAttribute('data-open') === 'true';
      if (open) {
        close();
      } else {
        nav.setAttribute('data-open', 'true');
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.getAttribute('data-open') === 'true') {
        close();
        burger.focus();
      }
    });

    // Sprungziele auf der Seite selbst schliessen das Panel.
    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) close();
    });

    // Beim Wechsel auf breite Fenster nie ein offenes Panel zuruecklassen.
    var wide = window.matchMedia('(min-width: 990px)');
    var onWide = function (event) { if (event.matches) close(); };
    if (wide.addEventListener) wide.addEventListener('change', onWide);
    else if (wide.addListener) wide.addListener(onWide);
  }

  /* ── Abschnitte blenden beim Scrollen ein ────────────────────────────── */
  var targets = document.querySelectorAll('.sw-reveal');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-visible'); });
    return;
  }

  var revealer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      revealer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  Array.prototype.forEach.call(targets, function (el) { revealer.observe(el); });
})();
